<script setup lang="ts">
import { computed } from 'vue'
import type { SelectOption } from '@/types/page'

const props = withDefaults(defineProps<{
  modelValue?: string | number | boolean | string[] | null
  options: SelectOption[]
  placeholder?: string
  multiple?: boolean
  clearable?: boolean
  disabled?: boolean
  filterable?: boolean
  collapseTags?: boolean
  ariaLabel?: string
  inputId?: string
  size?: 'small' | 'default'
  popperWidth?: number
}>(), {
  modelValue: '',
  placeholder: '请选择',
  multiple: false,
  clearable: false,
  disabled: false,
  filterable: true,
  collapseTags: true,
  size: 'default',
  popperWidth: 240,
})

const emit = defineEmits<{
  'update:modelValue': [value: string | number | boolean | string[]]
  change: [value: string | number | boolean | string[]]
  blur: [event: FocusEvent]
}>()

const value = computed({
  get: () => props.modelValue ?? (props.multiple ? [] : ''),
  set: (next: string | number | boolean | string[]) => emit('update:modelValue', next),
})

function onChange(next: string | number | boolean | string[] | undefined): void {
  emit('change', next ?? (props.multiple ? [] : ''))
}
</script>

<template>
  <el-select
    v-model="value"
    class="pro-select"
    :placeholder="placeholder"
    :multiple="multiple"
    :clearable="clearable"
    :disabled="disabled"
    :filterable="filterable"
    :collapse-tags="collapseTags"
    :id="inputId"
    :aria-label="ariaLabel"
    :size="size"
    :popper-class="'pro-select-popper'"
    :teleported="true"
    @change="onChange"
    @blur="emit('blur', $event)"
  >
    <el-option
      v-for="item in options"
      :key="String(item.value)"
      :label="item.label"
      :value="item.value"
      :disabled="item.disabled"
    >
      <span class="pro-select__option">
        <span>{{ item.label }}</span>
        <small v-if="item.description">{{ item.description }}</small>
      </span>
    </el-option>
  </el-select>
</template>

<style scoped>
.pro-select { width: 100%; }
.pro-select__option { display: flex; align-items: center; gap: 8px; width: 100%; }
.pro-select__option small { margin-left: auto; color: var(--c-faint); font-size: 10px; }
</style>
